import { DefaultError, InfiniteData, QueryKey, useInfiniteQuery, useQueryClient } from "@tanstack/react-query"
import { produce } from "immer"
import { first, flatten, isFunction, isObject, last } from "lodash"




export const useAdvancedInfiniteQuery = <TQueryFnData, TError = DefaultError, TData = InfiniteData<TQueryFnData>, TQueryKey extends QueryKey = QueryKey, TPageParam = unknown>
  (options: Parameters<typeof useInfiniteQuery<TQueryFnData,
    TError,
    TData,
    TQueryKey,
    TPageParam>>[0]) => {
  const queryClient = useQueryClient()

  const queryRes = useInfiniteQuery
    <TQueryFnData,
      TError,
      TData,
      TQueryKey,
      TPageParam>(options)


  const updateCb = (cb: (draft: any) => void) => {
    queryClient.setQueryData(options.queryKey, (oldData) => {
      if (!oldData) return
      return produce(oldData, cb)
    })
  }

  const push = (data) => {
    updateCb((draft: any) => {
      (last(draft?.pages) as any).push(data)
    })
  }

  const unshift = (data) => {
    updateCb((draft: any) => {
      (first(draft?.pages) as any).unshift(data)
    })
  }

  const update = (find, data) => {
    updateCb((draft: any) => {
      wrapper: for (const page of draft.pages) {
        for (const [index, item] of page.entries()) {

          if (find(item)) {

            if (isFunction(data)) page[index] = data(item)
            else if (isObject(data)) page[index] = data
            break wrapper
          }
        }
      }

    })
  }

  /** 更新所有匹配项（不像 update 只改第一条就停） */
  const updateAll = (find, data) => {
    updateCb((draft: any) => {
      for (const page of draft.pages) {
        for (const [index, item] of page.entries()) {
          if (find(item)) {
            if (isFunction(data)) page[index] = data(item)
            else if (isObject(data)) page[index] = data
          }
        }
      }
    })
  }

  const remove = (find) => {
    updateCb((draft: any) => {
      wrapper: for (const page of draft.pages) {
        for (const [index, item] of page.entries()) {
          if (find(item)) {
            page.splice(index, 1)
            break wrapper
          }
        }
      }

    })
  }

  const find = (find) => {
    return flatten((queryRes.data as any)?.pages || []).find(find)
  }


  return {
    ...queryRes,
    push,
    unshift,
    update,
    updateAll,
    updateCb,
    remove,
    find
  }
}